package com.daytimegaming.ourdailyfinances.domain.usecase

import com.daytimegaming.ourdailyfinances.domain.Response
import com.daytimegaming.ourdailyfinances.domain.model.Dashboard
import com.daytimegaming.ourdailyfinances.domain.model.DashboardDetail
import com.daytimegaming.ourdailyfinances.domain.model.DashboardInvite
import com.daytimegaming.ourdailyfinances.domain.model.JoinedDashboard
import com.daytimegaming.ourdailyfinances.domain.model.DashboardPreview
import com.daytimegaming.ourdailyfinances.domain.repository.DashboardRepository
import kotlinx.coroutines.flow.Flow

class GetDashboards(private val repo: DashboardRepository) {
    operator fun invoke(): Flow<Response<List<Dashboard>>> = repo.getDashboards()
}

class GetDashboardDetail(private val repo: DashboardRepository) {
    operator fun invoke(dashboardId: String): Flow<Response<DashboardDetail>> =
        repo.getDashboardDetail(dashboardId)
}

class CreateDashboard(private val repo: DashboardRepository) {
    suspend operator fun invoke(name: String): Response<Dashboard> = repo.createDashboard(name)
}

class AddDashboardAccount(private val repo: DashboardRepository) {
    suspend operator fun invoke(dashboardId: String, accountId: String): Response<Unit> =
        repo.addDashboardAccount(dashboardId, accountId)
}

class CreateInvite(private val repo: DashboardRepository) {
    suspend operator fun invoke(dashboardId: String): Response<DashboardInvite> =
        repo.createInvite(dashboardId)
}

class RevokeInvite(private val repo: DashboardRepository) {
    suspend operator fun invoke(dashboardId: String, code: String): Response<Unit> =
        repo.revokeInvite(dashboardId, code)
}

class PreviewInviteCode(private val repo: DashboardRepository) {
    suspend operator fun invoke(inviteCode: String): Response<DashboardPreview> =
        repo.previewInviteCode(inviteCode)
}

class JoinDashboard(private val repo: DashboardRepository) {
    suspend operator fun invoke(inviteCode: String): Response<JoinedDashboard> =
        repo.joinDashboard(inviteCode)
}

class LeaveDashboard(private val repo: DashboardRepository) {
    suspend operator fun invoke(dashboardId: String): Response<Unit> =
        repo.leaveDashboard(dashboardId)
}

class RemoveDashboardAccount(private val repo: DashboardRepository) {
    suspend operator fun invoke(dashboardId: String, accountId: String): Response<Unit> =
        repo.removeDashboardAccount(dashboardId, accountId)
}

class UpdateDashboard(private val repo: DashboardRepository) {
    suspend operator fun invoke(dashboardId: String, name: String): Response<Unit> =
        repo.updateDashboard(dashboardId, name)
}

class DeleteDashboard(private val repo: DashboardRepository) {
    suspend operator fun invoke(dashboardId: String): Response<Unit> =
        repo.deleteDashboard(dashboardId)
}

class AddDashboardRealEstateHolding(private val repo: DashboardRepository) {
    suspend operator fun invoke(dashboardId: String, realEstateHoldingId: String): Response<Unit> =
        repo.addDashboardRealEstateHolding(dashboardId, realEstateHoldingId)
}

class RemoveDashboardRealEstateHolding(private val repo: DashboardRepository) {
    suspend operator fun invoke(dashboardId: String, realEstateHoldingId: String): Response<Unit> =
        repo.removeDashboardRealEstateHolding(dashboardId, realEstateHoldingId)
}

class DashboardUseCase(
    val GetDashboards: GetDashboards,
    val GetDashboardDetail: GetDashboardDetail,
    val CreateDashboard: CreateDashboard,
    val AddDashboardAccount: AddDashboardAccount,
    val CreateInvite: CreateInvite,
    val RevokeInvite: RevokeInvite,
    val PreviewInviteCode: PreviewInviteCode,
    val JoinDashboard: JoinDashboard,
    val LeaveDashboard: LeaveDashboard,
    val RemoveDashboardAccount: RemoveDashboardAccount,
    val UpdateDashboard: UpdateDashboard,
    val DeleteDashboard: DeleteDashboard,
    val AddDashboardRealEstateHolding: AddDashboardRealEstateHolding,
    val RemoveDashboardRealEstateHolding: RemoveDashboardRealEstateHolding,
)
